<template>
  <div>
    <Form ref="searchForm" :label-width="70" :model="form">
      <FormItem label="搜索进程" style="width:100%;margin:10px 0 ;">
        <Input
          type="text"
          style="width:300px;"
          v-model="form.barId"
          placeholder=""
          search
          enter-button="搜索"
        />
      </FormItem>
    </Form>
    <div class="testCon pr">
      <Table
        stripe
        row-key="id"
        border
        height="454"
        :columns="columns"
        :data="newDnslog"
      >
        <template slot-scope="{ row, index }" slot="name">
          <strong>DNS</strong>
        </template>
        <template slot-scope="{ row, index }" slot="dir">
          <strong v-if="row.dir == 0">发出</strong>
          <strong v-else>接收</strong>
        </template>
      </Table>
      <div class="scrollbar" ref="scrollbar">
        <div ref="inScrollbar" :style="{ height: scrollHeight }"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['data'],
  data() {
    return {
      newDnslog: [],
      scrollHeight: 0,
      scrollbarTop: '',
      size: 13,
      form: {
        barId: '',
      },
      columns: [
        {
          title: '协议',
          sortable: true,
          align: 'center',
          tree: true,
          tooltip: true,
          slot: 'name',
          tooltip: true,
          width: 120,
        },
        {
          title: '时间',
          key: 'time',
          sortable: true,
          align: 'center',
          tree: true,
          tooltip: true,
          width: 200,
        },
        {
          title: 'PID',
          key: 'pid',
          sortable: true,
          align: 'center',
          tree: true,
          tooltip: true,
          width: 120,
        },
        {
          title: '进程名',
          key: 'time',
          sortable: true,
          align: 'center',
          tree: true,
          tooltip: true,
          width: 120,
        },
        {
          title: '方向',
          sortable: true,
          align: 'center',
          slot: 'dir',
          tooltip: true,
          width: 120,
        },
        {
          title: '本地地址》远程地址',
          key: 'addr',
          sortable: true,
          align: 'center',
          tree: true,
          tooltip: true,
        },
        {
          title: '信息',
          key: 'buf',
          sortable: true,
          align: 'center',
          tree: true,
          tooltip: true,
        },
      ],
      dataSource: [],
    }
  },
  watch: {
    data() {
      this.getData()
    },
  },
  mounted() {
    this.$refs.scrollbar.addEventListener(
      'scroll',
      (e) => {
        this.scrollbarTop = this.$refs.scrollbar.scrollTop
        this.getData()
      },
      false
    )
    this.getData()
  },
  methods: {
    getData() {
      this.newDnslog = []
      this.scrollHeight = this.data.length * 32 + 'px'
      let newData = [...this.data]
      let index = Number(this.scrollbarTop) / 32
      if (newData.length <= this.size) {
        this.newDnslog = newData.slice(0, this.size)
      } else {
        let len
        if (Number(parseInt(index)) + this.size > newData.length) {
          len = newData.length
        } else {
          len = Number(parseInt(index)) + this.size
        }
        this.newDnslog = newData.slice(Number(parseInt(index)), len)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.scrollbar {
  height: 454px;
  width: 30px;
  right: 0px;
  position: absolute;
  overflow: auto;
  top: 0;
}
</style>
